module.exports = __webpack_public_path__ + "img/account-reviewer.bf3c7c23.svg";